

<nav style="background-color: rgb(0, 128, 255);">
	<div class="container">
		<div class="row">
			<div class="text-center col-sm-12 col-md-2 col-lg-2 col-xl-2">
				<img (click)="clicksound()" (mouseenter)="hoversound()" routerLink="/accueiladmin" src="../assets/img/homeicon.png" width="30" height="30" />
			</div>
			<div class="text-center text-left col-sm-12 col-md-5 col-lg-5 col-xl-5">
				<h4>
					<button type="button" (click)="clicksound()" (mouseenter)="hoversound()" routerLink="/ajouter" class="btn btn-outline-light btn-sm">Ajouter</button> &nbsp;
      
					<button type="button" (click)="clicksound()" (mouseenter)="hoversound()" routerLink="/modifier" class="btn btn-outline-light btn-sm">Modifier</button> &nbsp;
      
					<button type="button" (click)="clicksound()" (mouseenter)="hoversound()" routerLink="/supprimer" class="btn btn-light btn-sm">Supprimer</button> &nbsp;
      
					<button type="button" (click)="clicksound()" (mouseenter)="hoversound()" routerLink="/chercher" class="btn btn-outline-light btn-sm">Chercher</button> &nbsp;
      
					<button type="button" (click)="clicksound()" (mouseenter)="hoversound()" routerLink="/consulter" class="btn btn-outline-light btn-sm">Consulter</button> &nbsp;
				</h4>
			</div>
			<div class=" text-center col-sm-12 col-md-3 col-lg-3 col-xl-3">
				<h4 id="connectnomm"> 
					<button type="button" (click)="deconnecter()"  (click)="clicksound()" (mouseenter)="hoversound()" class="btn btn-outline-dark btn-sm">Déconnecter</button> &nbsp;
				</h4>
			</div>
			<div class="text-center col-sm-12 col-md-2 col-lg-2 col-xl-2">
				<h4>
					<button type="button" (click)="clicksound()" (mouseenter)="hoversound()" class="btn btn-outline-warning btn-sm">Contacter</button> &nbsp;
      
					<input (click)="clicksound()" (mouseenter)="hoversound()" (click)="aproposderun()" type="button" name="aproposde" id="aproposde" class="btn btn-outline-warning btn-sm" value="À propos de"> &nbsp;
					</h4>
				</div>
			</div>
		</div>
	</nav>
	<br>
		<div class="container">
			<div class="row">
				<div class="text-center col-sm-12 col-md-8 col-lg-8 col-xl-6">
					<h1 style="font-size:50px;">Gestion des Employés</h1>
				</div>
				<div class="text-center col-sm-12 col-md-8 col-lg-8 col-xl-4">
					<br>
						<h3>Suppression d'un employé</h3>
					</div>
					<div class="text-center col-sm-12 col-md-8 col-lg-8 col-xl-2">
						<img src="../assets/img/supprimericon.png"  width="60" height="50" />
					</div>
				</div>
			</div>
			<br>
				<form>
					<div class="text-center-sm container">
                        <div class="row">
                            <div class="col-sm-12 col-md-7 col-lg-5 col-xl-5">
                                <h2>EID de l'employé à supprimer 
                                    <input type="text" style="width: 90px; font-size:18px;" name="eid" id="eid" value="8 chiffres" pattern="[0-9]{8}">
                                    </h2>
                                </div>
                                <div class="col-sm-12 col-md-4 col-lg-4 col-xl-4">
                                    <input type="button" (click)="backend_supprimer_chercher()" (mouseenter)="hoversound()" class="btn btn-warning btn-big " name="verifier" id="verifier" value="Vérifier l'existance de ce Employé">
                                                          
                                                          </div>
                            </div>
                            <br>
                            <br>
                            <br>
						<div class="row">
							<div class="col-sm-12 col-md-4 col-lg-4 col-xl-4">

                                  
                                    <div class="row">
                                        <div class="col-sm-12 col-md-12 col-lg-12 col-xl-12">
                                          <h2>Prénom <input type="text" style="font-size:18px;" name="prenom" id="prenom" value="" pattern="[A-z0-9À-ž\s]{3,30}" disabled>&nbsp;&nbsp;&nbsp;
                                            </h2>
                                          </div>
                                          <br>
                                          <div class="col-sm-12 col-md-12 col-lg-12 col-xl-12">
                                            <h2>Nom  &nbsp;&nbsp;&nbsp; <input type="text" style="font-size:18px;" name="nom" id="nom" value="" pattern="[A-z0-9À-ž\s]{3,30}" disabled>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                              </h2>
                                              <br>
                                            </div>
                                            </div>
                                </div>
                                <div class=" text-center col-sm-12 col-md-2 col-lg-2 col-xl-2">
                                    <h2>CIN 
                                       <h4> <input type="text" style="width: 90px; font-size:18px;" name="cin" id="cin" value="" pattern="[0-9]{8}" disabled></h4> 
                                        </h2>
                                        <br>
                                </div>

                                <div class=" text-center col-sm-12 col-md-3 col-lg-3 col-xl-3">
                                    <h2> Liste des Tâche</h2>
                                    <select style="width: 250px; font-size:18px;" name="tlist" id="tlist" disabled>
                                      <option value="tilist">appuyez pour l'affichier</option>
                                    </select>
                                    <br><br>
                                   
                            
                                   
                                </div>

                                <div class=" text-center col-sm-12 col-md-3 col-lg-3 col-xl-3" id="imgg">
                                    <img src="../assets/img/ajoutericon.png"  width="120" height="120" /> <br><br>
                                    <h2> Photo</h2>
                                </div>
                            </div>
                            <br><br><br><br>
                            <h3 class="text-end">êtes-vous sûr de vouloir supprimer cet employé ? (cela ne peut pas être annulé !) </h3>
                            <hr>
                            <input type="button" (click)="backend_supprimer()" (mouseenter)="hoversound()" style="float: right;" class="btn btn-primary btn-lg" name="supprimersub" id="supprimersub" value="Supprimer Employé" disabled>&nbsp;&nbsp;&nbsp;

                              <br>&nbsp;
                                <br>&nbsp;

                        </div>
                                        
                                                              </form>
